import SetupSettings 				from "../settings/settings";
import Service 						from "./../../Libs/Service";

import { Server } 					from "./Server.js"

let Monitoring = new Service({

	Name: "Monitoring",

	Libraries: [],

	Events: {

	},

	Actions: {

		'Log': function(data) {

			this.setLog(data);

			Broadcast.call("Monitoring Log", [data]);

		},

		'ProcessStart': function(data) {

			this.setProcess(data);

		},

		'ProcessEnd': function(data) {

			this.unsetProcess(data);

		}

	},

	init() {

		this.channels = {};

		//Информация об активных серверных процессах (например сжатие ассетов)
		this.activeProcesses = {
			"asset-compress": {},
			"release-build": {}
		};

		//Информация об ошибках активных серверных процессов (например сжатие ассетов)
		this.activeProcessesErrors = {
			"asset-compress": {},
			"release-build": {}
		};

		window.addEventListener("error", e => {

			this.clientError(e.message, e.stack, true);

		});

	},

	//Отправляем на сервер клиентскую ошибку
	clientError(errOrMessage, stack = null, isCaught = false) {

		if (!stack) stack = Error().stack;

		Server.sendToServer({Error: {message: errOrMessage, stack: stack}});

		if (SetupSettings.dev && !isCaught) console.error(errOrMessage);

	},

	setLog(data) {

		if (data.channel && data.message) {

			if (!this.channels[data.channel]) this.channels[data.channel] = {state: 'done', messages: []};

			if (data.message.out) data.message.out = data.message.out.replace(/\n/g, '<br>');
			if (data.message.err) data.message.err = data.message.err.replace(/\n/g, '<br>');

			if ('done' in data.message) {

				this.channels[data.channel].state = 'done';

				if (data.channel.indexOf('pull-project-') === 0) Broadcast.call("Pull Project Done", [data.message.projectId]);
				else if (data.channel.indexOf('clone-project') === 0) Broadcast.call("Clone Project Done", [data.message.projectId]);

			} else {

				this.channels[data.channel].state = 'waiting';

			}

			this.channels[data.channel].messages.push(data.message);

			Broadcast.call("Monitoring Channel Updated", [data.channel, this.channels[data.channel].state, this.channels[data.channel].messages]);

		}

	},

	getChannelState(channel_name) {

		if (!this.channels[channel_name]) return 'done';

		return this.channels[channel_name].state || 'done';

	},

	clearChannel(channel_name) {

		if (!this.channels[channel_name]) return;

		this.channels[channel_name].messages = [];
		this.channels[channel_name].state = 'done';

		Broadcast.call("Monitoring Channel Updated", [channel_name, this.channels[channel_name].state, this.channels[channel_name].messages]);

	},

	setProcess(process_data) {

		this.activeProcesses[process_data.type][process_data.name] = true;
		if (this.activeProcessesErrors[process_data.type]?.[process_data.name]) delete this.activeProcessesErrors[process_data.type][process_data.name];

		Broadcast.call(`Active Processes Changed:${process_data.type}`, [process_data]);

	},

	unsetProcess(process_data) {

		delete this.activeProcesses[process_data.type][process_data.name];

		Broadcast.call(`Active Processes Changed:${process_data.type}`, [process_data]);

	},

	setProcessError(process_data, err) {

		this.unsetProcess(process_data);

		this.activeProcessesErrors[process_data.type][process_data.name] = err;

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Monitoring) Monitoring = window.Monitoring;
else window.Monitoring = Monitoring;

export { Monitoring }

